import { classNames } from 'libs/react';
import { ApolloError } from '@apollo/client';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Error.scss';
/**
 * @component Error
 * @since 1.0.0
 */
export function Error(props) {
    const { style, title, infos, picto, error } = Object.assign({ style: 'normal' }, props);
    /**
     * @function onSend
     * @since 1.0.0
     * @hidden
     */
    function onSend() {
        let subject = 'An error occured';
        let message = [alert, stack].join('\n');
        subject = encodeURIComponent(subject);
        message = encodeURIComponent(message);
        window.open(`mailto:?subject=${subject}&body=${message}`);
    }
    const alert = getErrorAlert(error);
    const stack = getErrorStack(error);
    const className = classNames('error', 'error--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "error-main" },
            React.createElement("div", { className: "error-head" },
                picto && React.createElement(Icon, { className: "error-picto", value: picto }),
                title && React.createElement(Text, { className: "error-title", value: title }),
                infos && React.createElement(Text, { className: "error-infos", value: infos })),
            React.createElement("div", { className: "error-body" }, alert && React.createElement("div", { className: "error-alert" }, alert)))));
}
/**
 * @function getErrorAlert
 * @since 1.0.0
 * @hidden
 */
function getErrorAlert(error) {
    let alert = '';
    if (error instanceof ApolloError) {
        const networkError = error.networkError;
        const errors = (networkError &&
            networkError.result &&
            networkError.result.errors);
        if (errors)
            Object.values(errors).forEach((error) => {
                alert += error.message + '\n';
            });
    }
    else {
        alert = error.message;
    }
    return alert;
}
/**
 * @function getErrorStack
 * @since 1.0.0
 * @hidden
 */
function getErrorStack(error) {
    return error.stack;
}
